import React from 'react';

import { calculateBlankPassingRates } from '../../libs/calculateBlankPassingRates';

interface CueTemplate {
  conceptResults: any[];
  cue: string;
  feedback: string;
  optimal: boolean;
}

interface BlankByBlankGrading {
  [key: string]: CueTemplate[];
}

interface Response {
  text: string;
  [key: string]: any;
}

interface Question {
  blankByBlankGrading?: BlankByBlankGrading;
  caseInsensitive?: boolean;
  prompt: string;
  [key: string]: any;
}

interface BlankPassingRateHeaderProps {
  responses: Response[];
  question: Question;
}

export const BlankPassingRateHeader: React.FC<BlankPassingRateHeaderProps> = ({
  responses,
  question
}) => {
  const passingRates = calculateBlankPassingRates(responses, question);

  if (passingRates.length === 0) {
    return null;
  }

  return (
    <div className="blank-passing-rate-header">
      {passingRates.map((rate, index) => (
        <React.Fragment key={index}>
          {index > 0 && ' | '}
          <span className="blank-passing-rate">
            Blank {index + 1} passing rate: {rate}%
          </span>
        </React.Fragment>
      ))}
    </div>
  );
};
